import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import type { ResourceType } from '../ResourceList'

import emptyImage from '@static/images/resource-list/no-items.jpg'
import './EmptyList.css'

type EmptyStateVariant = 'empty' | 'no-results'

interface EmptyStateProps {
  variant: EmptyStateVariant
  type: ResourceType
}

const CREATE_PATHS: Record<ResourceType, string> = {
  query: '/query-builder/new',
  dashboard: '/dashboard-builder/new'
}

export default function EmptyList({ variant, type }: EmptyStateProps) {
  return (
    <div className={`empty-list empty-list--${variant}`}>
      <img src={emptyImage} alt="" aria-hidden="true" />
      <h2>
        <FormattedMessage
          id={
            variant === 'no-results'
              ? 'empty-state.no-results.title'
              : `empty-state.empty.${type}.title`
          }
        />
      </h2>
      <p>
        <FormattedMessage
          id={
            variant === 'no-results'
              ? 'empty-state.no-results.description'
              : `empty-state.empty.${type}.description`
          }
        />
      </p>
      {variant === 'empty' && (
        <Link className="button highlight-button" to={CREATE_PATHS[type]}>
          <span className="icon icon-plus"></span>
          <FormattedMessage id={`empty-state.empty.${type}.action`} />
        </Link>
      )}
    </div>
  )
}
